import Content from "./Content";
import Show from "./Show";

export { Content, Show };
